import React, { useCallback, useMemo, useState } from 'react';
import { observer } from 'mobx-react';

import { WidgetBase } from 'src/libs/ui-kit/widget-base/WidgetBase';
import { IWidgetProps } from 'src/libs/ui-kit/widget-base/WidgetBase.interface';
import { ExpandableRowsContainer } from 'src/libs/ui-kit/expandable-widget-table/ExpandableRowsContainer';
import { ExpandableWidgetTable } from 'src/libs/ui-kit/expandable-widget-table/ExpandableWidgetTable';

import { CustomerLoyaltyModal, OperationInfoModal, Row, StoreContext } from './components';
import { ILoyaltyBonusOperation, ILoyaltyBonusServiceProvider } from './interfaces';
import { LoyaltyBonusStore } from './store';

import styles from './styles.module.scss';

interface ILoyaltyBonusWidgetProps extends IWidgetProps {
  id: string;
  loyaltyBonusService: ILoyaltyBonusServiceProvider;
}

export const LoyaltyBonusWidget = observer(({ id, col, loyaltyBonusService }: ILoyaltyBonusWidgetProps) => {
  const store = useMemo(
    () =>
      new LoyaltyBonusStore({
        userId: id,
        loyaltyBonusService,
      }),
    [id, loyaltyBonusService],
  );

  const buttons = useMemo(() => [{ title: 'Изменить', clickHandler: store.openBonusModal }], [store.openBonusModal]);

  const [displayedOperation, showOperation] = useState<ILoyaltyBonusOperation | null>(null);
  const hideOperation = useCallback(() => showOperation(null), []);

  const LoyaltyBonusTableRow = (operation) => <Row operation={operation} showOperation={showOperation} />;

  return (
    <StoreContext.Provider value={store}>
      <WidgetBase
        title={<>Бонусный счет: {store.totalSum}</>}
        col={col}
        buttons={buttons}
        isLoading={store.isLoading}
        isShown
        hasError={store.hasError}>
        <div className="px-5">
          <ExpandableWidgetTable total={store.operations.length} className={styles.table} hover>
            <thead>
              <tr>
                <th className="border-0 text-tiny pt-0">Тип операции</th>
                <th className="border-0 text-tiny pt-0">Причина</th>
                <th className="border-0 text-tiny pt-0">Описание</th>
                <th className="border-0 text-tiny pt-0">Сумма</th>
                <th className="border-0 text-tiny pt-0">Дата</th>
                <th className="border-0 text-tiny pt-0">Ответственный</th>
              </tr>
            </thead>

            <tbody>
              <ExpandableRowsContainer
                keyBy="id"
                data={store.operations}
                Component={LoyaltyBonusTableRow}></ExpandableRowsContainer>
            </tbody>
          </ExpandableWidgetTable>
        </div>

        <CustomerLoyaltyModal />
        <OperationInfoModal data={displayedOperation} onHide={hideOperation} />
      </WidgetBase>
    </StoreContext.Provider>
  );
});
